<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>교재정보</div>
      <!-- Breadcrumb right aligned-->
      <!-- <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">개체정보</li>
      </ol> -->
    </div>


    <!-- 상세 -->
    <div class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered" style="background-color: #f7f7f7;">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>교재시퀀스</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.bookSeq')}"
                       v-model="data.row.bookSeq"  v-validate="''" name="bookSeq"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.fileSeq')" class="invalid-feedback">{{
                    errors.first('edit.fileSeq')
                  }}</span>
              </td>
              <th>콘텐츠시퀀스</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.contSeq')}"
                       v-model="data.row.contSeq"  v-validate="''" name="contSeq"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.fileSeq')" class="invalid-feedback">{{
                    errors.first('edit.fileSeq')
                  }}</span>
              </td>
            </tr>
            <tr class="textbookSelect">
              <th>과목</th>
              <td>
                <b-form-select v-model="data.row.subjectCd" :options="subjectCd" class="not-select" style="text-align:left;"></b-form-select>
              </td>
              <th>교재명</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.contSeq')}"
                       v-model="data.row.textbookNm"  v-validate="''" name="contSeq"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.fileSeq')" class="invalid-feedback">{{
                    errors.first('edit.fileSeq')
                  }}</span>
              </td>
            </tr>
             <tr>
              <th>저자</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.orgFileNm')}"
                       v-model="data.row.author"  v-validate="''" name="orgFileNm"
                       style="width: 100%" readonly/>
                <span v-show="errors.has('edit.orgFileNm')" class="invalid-feedback">{{
                    errors.first('edit.orgFileNm')
                  }}</span>
              </td>
              <th>개정년도</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.size')}"
                       :value="data.row.pubDt"  v-validate="''" name="size" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.size')" class="invalid-feedback">{{ errors.first('edit.size') }}</span>
              </td>
            </tr>
            <tr>
              <th>학교급</th>
              <td>
                 <span v-show="data.row.schlE1ChkYn == 'Y' ? true : false">{{data.row.schlE1ChkYn == 'Y' ? '초등1' : ''}}</span>
                 <span v-show="data.row.schlE2ChkYn == 'Y' ? true : false">{{data.row.schlE2ChkYn == 'Y' ? '초등2' : ''}}</span>
                 <span v-show="data.row.schlE3ChkYn == 'Y' ? true : false">{{data.row.schlE3ChkYn == 'Y' ? '초등3' : ''}}</span>
                 <span v-show="data.row.schlE4ChkYn == 'Y' ? true : false">{{data.row.schlE4ChkYn == 'Y' ? '초등4' : ''}}</span>
                 <span v-show="data.row.schlE5ChkYn == 'Y' ? true : false">{{data.row.schlE5ChkYn == 'Y' ? '초등5' : ''}}</span>
                 <span v-show="data.row.schlE6ChkYn == 'Y' ? true : false">{{data.row.schlE6ChkYn == 'Y' ? '초등6' : ''}}</span>
                 <span v-show="data.row.schlM1ChkYn == 'Y' ? true : false">{{data.row.schlM1ChkYn == 'Y' ? '중등1' : ''}}</span>
                 <span v-show="data.row.schlM2ChkYn == 'Y' ? true : false">{{data.row.schlM2ChkYn == 'Y' ? '중등2' : ''}}</span>
                 <span v-show="data.row.schlM3ChkYn == 'Y' ? true : false">{{data.row.schlM3ChkYn == 'Y' ? '중등3' : ''}}</span>
                 <span v-show="data.row.schlH1ChkYn == 'Y' ? true : false">{{data.row.schlH1ChkYn == 'Y' ? '고등1' : ''}}</span>
                 <span v-show="data.row.schlH2ChkYn == 'Y' ? true : false">{{data.row.schlH2ChkYn == 'Y' ? '고등2' : ''}}</span>
                 <span v-show="data.row.schlH3ChkYn == 'Y' ? true : false">{{data.row.schlH3ChkYn == 'Y' ? '고등3' : ''}}</span>
              </td>
              <th>채널설정</th>
              <td>
              </td>
            </tr>
            <tr>
              <th>샘플여부</th>
              <td>
               <span>{{data.row.freeYn == 'Y' ? '무료(샘플)' : '유료'}}</span>
              </td>
              <th>노출여부</th>
              <td>
                <span>{{data.row.useYn == 'Y' ? '노출' : '비노출'}}</span>
              </td>
            </tr>
            <tr>
              <th>담당자</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.regId')}"
                       :value="data.row.manNm"  v-validate="''" name="regId" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.regId')" class="invalid-feedback">{{ errors.first('edit.regId') }}</span>
              </td>
              <th>수정자/수정일</th>
              <td>
                <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.regDt')}"
                       :value="data.row.updId+'('+data.row.updDt+')'"  v-validate="''" name="regDt" style="width: 100%"
                       readonly/>
                <span v-show="errors.has('edit.regDt')" class="invalid-feedback">{{ errors.first('edit.regDt') }}</span>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div>
      <div div class="content-heading mt-1" >
        <div>매핑정보</div>
      </div>
      <div class="card card-default">
        <div class="card-body">
          <form data-vv-scope="editMpp">
            <table class="table table-bordered">
              <colgroup>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
              </colgroup>
              <tr>
                <th>콘텐츠 용도</th>
                <td>
                  <b-input-group>
                    <div>
                      <b-form-select v-model="dataMpp.row.purpTypeCd" :options="purpTypeCd">
                      </b-form-select>
                    </div>
                  </b-input-group>
                </td>
                <th>유료여부</th>
                <td>
                  <b-input-group>
                    <div>
                      <div class="form-check mb-2">
                        <input class="form-check-input" id='form-check-payYn' v-model="dataMpp.row.freeYn" true-value="Y"
                              false-value="N" type="checkbox"/>
                        <label class="form-check-label" for='form-check-payYn'>{{
                            data.row.payYn == 'Y' ? '유료' : '무료'
                          }}</label>
                      </div>
                      <div> ※ 체크하면 유료로 전환됩니다.</div>
                    </div>
                  </b-input-group>
                </td>
              </tr>
              <tr>
                <th>등록자/등록일</th>
                <td>
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('editMpp.regId')}"
                        :value="dataMpp.row.regId+'('+dataMpp.row.regDt+')'" v-validate="''" name="regId" style="width: 100%"
                        readonly/>
                  <span v-show="errors.has('editMpp.regId')" class="invalid-feedback">{{ errors.first('editMpp.regId') }}</span>
                </td>
                <th>수정자/수정일</th>
                <td>
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('editMpp.regDt')}" :value="dataMpp.row.updId+'('+dataMpp.row.updDt+')'" v-validate="''" name="regDt" style="width: 100%"
                        readonly/>
                  <span v-show="errors.has('editMpp.regDt')" class="invalid-feedback">{{ errors.first('editMpp.regDt') }}</span>
                </td>
              </tr>
            </table>
          </form>
        </div>
        <div class="card-footer">
          <div class="card-tool float-right">
            <b-button @click="close()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
            <b-button @click="removeMpp()" class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">매핑삭제</b-button>
            <b-button @click="[save(),saveMpp()]" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2 px-3">저장</b-button>
          </div>
        </div>
    </div>
  </div>
    <a id="fileDown" style="display:none;"></a> <!-- 다운로드용 가상 a-->   
    <a id="filePreview" style="display:none;" target="_blank" ></a> <!-- 미리보기용 가상 a-->    
    <!-- // 상세 -->
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getLmTextBookItem,deleteLmTextBook, saveLmTextBook,saveTextbook,getLmTextBookItemInfo} from "@/api/lm/LmTextBookApi";
import {getCsFileList, getCsFileItem, saveCsFile, deleteCsFile} from "@/api/cs/CsFileApi";
import {getCsFileMappingItem, saveCsFileMapping, deleteCsFileMapping, getCsFileMappingLocationList} from "@/api/cs/CsFileMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, purpTypeCd , fileTypeCd, fileDivCdMap, aws_cdn_pat,subjectCd} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Datepicker from 'vuejs-datepicker';
import Axios from 'axios';

export default {
  components: {SchDateRange, SchText, Pagenation, Datepicker},
  props: {
    fileSeq: '',
    orgContSeq: Number,
    mppdata: {},
  },
  setup(props, context) {
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 
    const dataMpp = reactive(_.cloneDeep((props.mppdata)));

    dataMpp.row.purpTypeCd == null ? '' : dataMpp.row.purpTypeCd;

    const loadData = async () => {
      // modal open
      if(props.fileSeq){
        data.params.fileSeq = props.fileSeq;

        let result = await getLmTextBookItemInfo({
          contSeq : props.orgContSeq,
        });
        data.row = result.data;
      }
    }
    const close = () =>{
        context.emit('modal-state');
    }


    onMounted(loadData);
    
    return {
      subjectCd,
      purpTypeCd,
      data,
      dataMpp,
      close,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}
function methods() {
  var context = {};
  context["saveCsFileMapping"] = saveCsFileMapping; // save item 
  context["deleteCsFileMapping"] = deleteCsFileMapping; // delete item
  context["getCsFileList"] = getCsFileList; // delete item
  context["saveLmTextBook"] = saveLmTextBook;  // save item  
  context["getCsFileMappingItem"] = getCsFileMappingItem;  // save item

    // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getCsFileList", context, _params);
  }



  // 맵핑정보 삭제
  async function removeMpp(_params) {
    if (!confirm('삭제하시겠습니까?')) {
      return;
    }
    _params = !_params ? this.dataMpp.row : _params
    await this.dataAction.execute("deleteCsFileMapping", context, _params);
    
    this.search();
  }
   // 저장
   async function save(){
    const validForm =  await this.$validator.validateAll('edit').then((result) => {
      return result;
    });
    if(validForm) {
      this.data.row.keywords = this.keywordText; 
      let _params = this.data.row
      await this.dataAction.execute("saveLmTextBook", context, _params);
      this.search();
    }
  }


  // 맵핑정보 저장
  async function saveMpp() {
    const validForm = await this.$validator.validateAll('editMpp').then((result) => {
      return result;
    });
    if (validForm) {
      let _params = this.dataMpp.row
      await this.dataAction.execute("saveCsFileMapping", context, _params);
      this.search();
    }
  }


  return { search,save, saveMpp,removeMpp}
}


</script>
